import { render } from "./withdrawal.vue?vue&type=template&id=1e7a23bc&scoped=true"
import script from "./withdrawal.vue?vue&type=script&lang=js"
export * from "./withdrawal.vue?vue&type=script&lang=js"

import "./withdrawal.vue?vue&type=style&index=0&id=1e7a23bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e7a23bc"]])

export default __exports__